"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTitle = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./PageTitle.pc.css");
const PageTitle = ({ title, subtitle, action, noCenter, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_9d1fc694', '_31f2c3ac', '_pub-31f2c3ac', '_pub-e1f3c93f', {
            '_31f2c3ac_no-center _pub-31f2c3ac_no-center _pub-e1f3c93f_no-center no-center': noCenter,
        }) },
        react_1.default.createElement("div", { className: (0, clsx_1.default)('_5707fdae', '_31f2c3ac', '_pub-31f2c3ac', '_pub-e1f3c93f') },
            react_1.default.createElement("h1", { className: (0, clsx_1.default)('_c3a500eb', '_31f2c3ac', '_pub-31f2c3ac', '_pub-e1f3c93f') }, title),
            react_1.default.createElement("h3", { className: (0, clsx_1.default)('_5aac5151', '_31f2c3ac', '_pub-31f2c3ac', '_pub-e1f3c93f') }, subtitle)),
        action && (react_1.default.createElement("div", { className: (0, clsx_1.default)('_eecf05f0', '_31f2c3ac', '_pub-31f2c3ac', '_pub-e1f3c93f', '_31f2c3ac_actions', '_pub-31f2c3ac_actions', '_pub-e1f3c93f_actions', 'actions') }, action))));
};
exports.PageTitle = PageTitle;
//# sourceMappingURL=PageTitle.js.map